import React from "react";

function About() {
  return (
    <section style={{ padding: "4rem 2rem", maxWidth: "900px", margin: "0 auto", lineHeight: "1.8", fontSize: "1.1rem" }}>
      <h1 style={{ textAlign: "center", fontSize: "2rem", marginBottom: "2rem" }}>About Samverkan</h1>

      <p>
        <strong>Samverkan</strong> was born from a love of science, nature, and the beauty found in how things work.
        With over <strong>25 years in the design and print industry</strong>, we’ve learned the art of form—how things look, feel, and flow.
        But somewhere along the way, we discovered the deeper satisfaction that comes from understanding <em>function</em>.
      </p>

      <p>
        Our journey took us from obsessing over perfect kerning and colour swatches to admiring the elegance of
        mathematical structures, the logic of coding, and the symmetry of the natural world.
        The things that work beautifully are often beautiful because they work well.
      </p>

      <p>
        That’s why we started Samverkan — a fusion of <strong>function + form</strong> expressed through thoughtful, minimal design.
        We make apparel for curious minds, critical thinkers, and quiet rebels.
        Every piece is a tribute to the overlap between logic and creativity.
      </p>

      <p>
        Whether it’s a hoodie that celebrates quantum mechanics, or a tee that nods to string theory, our goal is simple:
        to create clothing that feels good, fits well, and says something meaningful.
      </p>

     
   {/* Icon Section */}
   <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(260px, 1fr))",
          gap: "2rem",
          textAlign: "center",
        }}
      >
        <div>
          <img
            src="/images/icon-brain.svg"
            alt="Inspired by Ideas"
            style={{ width: "60px", marginBottom: "1rem" }}
          />
          <h3 style={{ marginBottom: "0.5rem" }}>Inspired by Ideas</h3>
          <p style={{ color: "#555", fontSize: "0.95rem" }}>
            Big thinking, playful curiosity and design grounded in intellect.
          </p>
        </div>

        <div>
          <img
            src="/images/icon-print.svg"
            alt="Built on Experience"
            style={{ width: "60px", marginBottom: "1rem" }}
          />
          <h3 style={{ marginBottom: "0.5rem" }}>Built on Experience</h3>
          <p style={{ color: "#555", fontSize: "0.95rem" }}>
            With 25 years in print, we know what makes things look and feel exceptional.
          </p>
        </div>

        <div>
          <img
            src="/images/icon-nature.svg"
            alt="Rooted in Nature"
            style={{ width: "60px", marginBottom: "1rem" }}
          />
          <h3 style={{ marginBottom: "0.5rem" }}>Rooted in Nature</h3>
          <p style={{ color: "#555", fontSize: "0.95rem" }}>
            The beauty of function and the logic of nature influence everything we create.
          </p>
        </div>
      </div>
    </section>
  );
}

export default About;